import DefaultModal from '../../../../../components/Modal/DefaultModal';
import React, { useCallback } from 'react';
import AccountInputs from '../../../Account/form/FormInputs/index';

const EditAccountModal = ({
  isModalOpen,
  onModalToggle,
  account,
  recordTypeId,
  setSelectedClient,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);

  if (!account || !recordTypeId) {
    return null;
  }

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      size="md"
      title="Alterar Conta"
      showCloseButton={false}
      modalContainerClasses="modal-md"
      {...props}
    >
      <div>
        <AccountInputs
          recordTypeId={recordTypeId}
          account={account}
          closeModal={closeModal}
          editAccount={true}
          setSelectedClient={setSelectedClient}
        />
      </div>
    </DefaultModal>
  );
};

export default EditAccountModal;
